<template>
    <div>
        <!-- Error/Warn -->
        <div>
            <alert></alert>
        </div>
        <!-- /Error/Warn -->
        <content>
            <div v-if="contentnav == 1"><!--  class="fond-select" -->
                <mainpagejumbotron v-on:listenerchild="listenerchild"></mainpagejumbotron>
            </div>
            <div v-if="contentnav == 2">
                <productlist :search_flag="search_flag"></productlist>
            </div>
            <div v-if="contentnav == 3">
                <productlist :search_flag="search_flag"></productlist>
            </div>
            <div v-if="contentnav == 4">
                <shoppingcart></shoppingcart>
            </div>
            <!--  <div class="modal fade" id="accountModal" tabindex="-1" aria-hidden="true" v-show="session"
                 ref="iframemodal">
                 <div class="modal-dialog modal-dialog-centered modal-xl">
                     <div class="modal-content rounded-0 border-0 shadow-lg">
                         <div id="iframe-close-button">
                             <button class="close ml-auto mt-2 mb-2 mr-4" type="button" id="closeAccountModal"
                                 data-dismiss="modal" aria-label="Close">
                                 <span aria-hidden="true">
                                     <svg class="icon icon-xs">
                                         <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                     </svg>
                                 </span>
                             </button>
                         </div>
                         <div class="modal-body p-1">
                             <div class="embed-responsive embed-responsive-16by9">
                                 <iframe name="my_account" id="my_account" class="embed-responsive-item"
                                     :src="my_account_url"></iframe>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
  -->

            <div id="accountModal"  tabindex="-1" class="modal fade" aria-modal="true" role="dialog">

                <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                    <div class="modal-content rounded-0 border-0 shadow-lg">
                        <header class="modal-header p-0">
                            <button type="button" id="closeAccountModal" data-dismiss="modal" aria-label="Close" class="close bg-white border position-absolute"><span aria-hidden="true">
                                <svg class="icon icon-xs"><use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink= "http://www.w3.org/1999/xlink "></use></svg>
                            </span></button>
                        </header>
                        <div class="modal-body embed-responsive p-1">
                            <iframe name="my_account" id="my_account" :src="my_account_url" class="embed-responsive-item"></iframe>
                        </div>
                    </div>
                </div>
            </div>




        </content>

    </div>
</template>

<script>
import mainpagejumbotron  from './MainPageJumbotron'
import productlist  from './ProductList'
import {EventBus}  from  './services/eventbus/event-bus'
import shoppingcart from './ShoppingCart'

import userApi from './services/api/user'
import projectApi from './services/api/project'
import configurationApi from './services/api/configuration'

import productdataApi from './services/api/productdataAPI'
import globalsApi from './services/api/globals'
import alert from './Alert'
import operatingpointApi from './services/api/operatingpointAPI'
import moment from "moment";



export default {
    components: {
        mainpagejumbotron,
        productlist,
        shoppingcart,
        alert,

    },
    props: [
        'configurationdata',
        'status',
        'categorydata',
    ],
    computed: {
        contentnav: {
            get() {
                return this.$store.state.globalData.contentnav
            },
            set(value) {
                this.$store.commit('globalData/updateContentnav', value)
            }
        },
        navigation: {
            get () {
                return this.$store.state.globalData.navigation
            },
            set (value) {
                this.$store.commit('globalData/updateNavigation', value)
            }
        },
        session: {
            get () {
                return this.$store.state.user.session
            },
            set (value) {
                this.$store.commit('user/updateSession', value)
            }
        },
        needLogin: {
            get () {
                return this.$store.state.user.needLogin
            },
            set (value) {
                this.$store.commit('user/updateNeedLogin', value)
            }
        },
        update: {
            get () {
                return this.$store.state.globalData.update
            },
            set (value) {
                this.$store.commit('globalData/updateUpdate', value)
            },
        },
        configuration: {
            get () {
                return this.$store.state.user.configuration
            },
            set (value) {
                this.$store.commit('user/updateConfiguration', value)
            }
        },
        shoppingcartlist:{
            get() {
                return this.$store.state.shoppingcart.shoppingcartlist
            },
            set (value) {
                this.$store.commit('shoppingcart/updateShoppingcartList', value)
            }
        },
        projectData: {
            get () {
                return this.$store.state.user.projectData
            },
            set (value) {
                this.$store.commit('user/updateProjectData', value)
            }
        },
        project: {
            get () {
                return this.$store.state.projectData.project
            },
            set (value) {
                this.$store.commit('projectData/updateProject', value)
            }
        },
        user: {
            get () {
                return this.$store.state.user.user
            },
            set (value) {
                this.$store.commit('user/updateUser', value)
            }
        },
        search_flag:  {
            get () {
                return this.$store.state.shoppingcart.search_flag
            },
            set (value) {
                this.$store.commit('shoppingcart/updateSearchFlag', value)
            }
        },
        op: {
            get() {
                return this.$store.state.operatingpoint.op;
            },
            set(value) {
                this.$store.commit('operatingpoint/updateop', value);
            }
        },
        feldererstate: {
            get() {
                return this.$store.state.globalData.feldererstate
            },
            set(value) {
                this.$store.commit('globalData/updateFeldererState', value)
            }
        },


    },
    data() {
        return {
            //contentnav: 1,
            //search_flag: 'op',

            my_account_url: '',
            showAccountModal: false,

        }
    },
    methods: {
        listenerchild(params) {
            EventBus.$emit('loadprodlist'); //in ProductList

            this.contentnav =  params.nav
            this.search_flag = params.searchflag
            //this.op= params.op
            // console.log('nav:' + this.contentnav + 'search_flag:' + this.search_flag)



            //this.$forceUpdate();


        },
        setIframeUrl(){
            var lang_local = this.$lang().locale
            if(this.session != null){
                axios.post('/user/access/token', {navigation: this.navigation}).then(response => {
                    console.log('MainPage setIframeUrl navigation:')
                    console.log(this.navigation)
                    console.log('MainPage setIframeUrl response:')
                    console.log(response)
                    //this.my_account_url = response.data.url + '/' + lang_local + '/' + '?access_token=' + response.data.access_token + '&language_id=1&target=' + response.data.navigation + '&service=1';// + response.data.service;
                    this.my_account_url = response.data.url + '/' + lang_local + '/' + '?access_token=' + response.data.access_token + '&target=' + response.data.navigation + '&service=2';// + response.data.service;
                    //https://test2.myaccount.heliosventilatoren.de/[[locale]]?access_token=[[accesstoken]]&target=profile&service=2
                    console.log(this.my_account_url)
                    this.$bvModal.show('accountModal')
                    this.navigation = ''
                }).catch(function (error) {
                    this.navigation = ''
                });
            }
        },

        openLogin () {
            this.needLogin = true;
        },
        fetchEventsList () {
            /* if(this.session && this.session.auth){
                userApi.refreshSession();
            } */
            if(this.user.auth){
                userApi.refreshSession();
            }
        },
        cancelAutoUpdate () {
            clearInterval(this.timer);
        },
        resetIframe(){
            this.my_account_url = ''
        },
        async getConfiguration(configuration) {
            /* console.log('Main getConfiguration:')
             console.log(configuration)
*/
            var articles =JSON.parse(JSON.stringify(this.user.articles))
//                console.log('articles:',articles);
            this.getUserProject().then(function(){
                var configurations_project = {}
                var config = {}
                this.projectData.forEach(function (projects) {
                    var value = projects.configurations.find((config) => config.id == configuration.configuration_id);

                    if(value !== undefined){
                        configurations_project = projects
                        config = value
                    }
                })
                if (configurations_project) {
                    var customer = {
                        id: null,
                        type: 0,
                        first_name: '',
                        last_name: '',
                        phone: '',
                        mobile: '',
                        email: '',
                        form_of_address:'',
                        company_name:''
                    }
                    if(configurations_project.contacts && configurations_project.contacts.length > 0) customer = configurations_project.contacts[0]

                    var now = moment();

                    var lastedit = moment(now, "DD.MM.YYYY");
                    /*
                                                if (config.updated.date!='undefined') {
                                                     var lastedit = moment( String(config.updated.date), "YYYY-MM-DD HH:mm:ss.SSSSSS").format("DD.MM.YYYY");

                                                }*/
                    Object.assign(this.project, configurations_project,  {

                        selection: 1,
                        project_id: configurations_project.id,
                        option: configurations_project.id,
                        id: configurations_project.id,
                        name: configurations_project.name,
                        number: configurations_project.number,
                        street: configurations_project.street,
                        post_code: configurations_project.post_code,
                        city: configurations_project.city,
                        country: configurations_project.country,
                        country_iso3: configurations_project.country_iso3,
                        description: configurations_project.description,
                        configuration: {
                            description: config.description,
                            editor: config.editor,
                            updated: lastedit
                        },
                        customer: customer,
                        useraccess: configurations_project.useraccess,
                        status: configurations_project.status,
                    })

                }
            }.bind(this))
            document.getElementsByTagName("body")[0].classList.add("is-loading");

            var response = await configurationApi.returnConfiguration(configuration);

            if(response.status >= 400){
                this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.load_configuration_faild')})
                return
            }
            this.$store.dispatch('operatingpoint/resetState')

            if(Object.keys(response.data.configuration).length > 0){
                this.project.configuration.description = response.data.configuration.description
            }

            this.configuration = response.data.configuration

            var materials=[]
            /*  var materials_source1=[] //master products
             var materials_source2=[] //user products */
            var lang_local = this.$lang().locale

            if(Object.keys(response.data.material).length > 0){
                response.data.material.forEach(function(product){
                    /* --
                    if (parseInt(product.productSource) == 1) {


                        var params={ref_no:product.productRefNo,version:product.productVersion,language_id: lang_local}  //navigator.language,
                        //request to slow=> wrong sort
                        productdataApi.getProductdata(params).then(responseproduct => {
                            var shoppingcartlist_product=responseproduct.data.productdata[0]
                            shoppingcartlist_product.position=product.position
                            shoppingcartlist_product.quantity=product.productQuantity
                            shoppingcartlist_product.discount_1= product.discount1??0;
                            shoppingcartlist_product.discount_2= product.discount2??0;
                            shoppingcartlist_product.price=product.productPrice
                            shoppingcartlist_product.positiontext=product.positiontext
                            shoppingcartlist_product.image=responseproduct.data.productdata[0].product_media.filter(item => item.media_type == 'image').map(function (image) { return image.path + image.filename })[0]
                            shoppingcartlist_product.description_short=responseproduct.data.productdata[0].product_descriptions[0].description_short;
                            shoppingcartlist_product.product_source = product.productSource
                            shoppingcartlist_product.productmarker = product.productMarker
                            materials.splice(product.position - 1, 0, shoppingcartlist_product);


                            //materials.push(shoppingcartlist_product)
                        })
                        .catch(function () {
                            console.log('MainPage Fehler productdataAPI.getProductdata');
                        });
                    }
                    else { */
                    var shoppingcartlist_product=product
                    shoppingcartlist_product.flag_fan=''
                    shoppingcartlist_product.ref_no=product.productRefNo
                    shoppingcartlist_product.version=''
                    shoppingcartlist_product.position=product.position
                    shoppingcartlist_product.quantity=product.productQuantity
                    shoppingcartlist_product.discount_1= product.discount1??0;
                    shoppingcartlist_product.discount_2= product.discount2??0;
                    shoppingcartlist_product.price=product.productPrice>0 ? product.productPrice.toFixed(2):0
                    shoppingcartlist_product.positiontext=product.positiontext
                    shoppingcartlist_product.image=''
                    shoppingcartlist_product.description_short=product.productDescription??''
                    shoppingcartlist_product.type=product.productDescription??''
                    shoppingcartlist_product.product_source = product.productSource
                    shoppingcartlist_product.productmarker = product.productMarker
                    shoppingcartlist_product.execution = product.productExecution

                    materials.splice(product.position - 1, 0, shoppingcartlist_product);

                    //materials.push(shoppingcartlist_product)

                    //-- }

                })



                //materials= [...materials_source1, ...materials_source2];

                //this.shoppingcartlist = response.data.material

            }
            //materials.sort((a, b) => a.position - b.position)


            //var materials_tmp=Object.assign({},materials);
            //var materials_tmp={}
            materials.forEach(function (item, index, material) {
                if (parseInt(item.productSource) == 1) {
                    console.log(' materials.productSource=1')
                    var params = { ref_no: item.productRefNo, version: item.productVersion, language_id: lang_local }  //navigator.language,
                    materials[index].version = item.productVersion;
                    productdataApi.getProductdata(params).then(responseproduct => {
                        // materials[index] =   { ...responseproduct.data.productdata[0], ...materials[index]};
                        materials[index] =   responseproduct.data.productdata[0];

                        materials[index].image = responseproduct.data.productdata[0].product_media.filter(item => item.media_type == 'image').map(function (image) { return image.path + image.filename })[0]
                        materials[index].description_short = responseproduct.data.productdata[0].product_descriptions[0].description_short;
                        materials[index].flag_fan = responseproduct.data.productdata[0].flag_fan;
                        materials[index].countaccessories = responseproduct.data.productdata[0].accessories.length;
                        materials[index].listprice =  responseproduct.data.productdata[0].product_prices.length>0 ? responseproduct.data.productdata[0].product_prices[0].price.toFixed(2):0;

                        materials[index].ref_no=item.productRefNo;
                        materials[index].version=item.productVersion;
                        materials[index].quantity=item.productQuantity;
                        materials[index].discount_1=item.discount1;
                        materials[index].discount_2=item.discount2;
                        materials[index].price=item.productPrice;
                        materials[index].positiontext=item.positiontext;
                        materials[index].type=item.type;
                        materials[index].product_source =item.productSource;
                        materials[index].productmarker=item.productMarker;
                        materials[index].execution=item.productExecution;
                        //materials[index].position =item.position;  // if this => drop not working


                        materials[index].country_price='';
                        materials[index].delivery='';
                        materials[index].difference='';
                        materials[index].freight_position='';
                        materials[index].languages_id='';
                        materials[index].newsletter='';
                        materials[index].note='';
                        materials[index].pressure='';
                        materials[index].pressure_type='';
                        materials[index].user_profiles_id='';
                        materials[index].vat='';
                        materials[index].volume_flow='';

                        if(item.searchFilterdata!==null) materials[index].op = JSON.parse(item.searchFilterdata);

                        //op: '{"op_must":{"ref_no":"03265","version":"030","execution":"0","language_id":"de","airflowrate":"40000","externalpressure":"400","airflow_unit":1,"externalpressure_unit":5,"externalpressuretyp":"stat","airflowrate_dev":[-10,10],"externalpressure_dev":[-10,10],"maxdba":"","airflowrate_is":40000,"externalpressure_is":400,"wsoll_is":19.505204158389144,"electricity":"0.00","elpower":"0.00","rpm":"1470","sfp":"0.000"},"op_is":{"airflowrate":40000,"externalpressure":400,"wsoll":19.505204158389144,"electricity":0,"elpower":0,"rpm":1470,"sfp":0}}'
                        //op: '{"op_must":{"ref_no":"03265","version":"030","execution":"0","language_id":"de","airflowrate":"40000","externalpressure":"400","airflow_unit":1,"externalpressure_unit":5,"externalpressuretyp":"stat","airflowrate_dev":[-10,10],"externalpressure_dev":[-10,10],"maxdba":"","airflowrate_is":40000,"externalpressure_is":400,"wsoll_is":19.505204158389144,"electricity":"0.00","elpower":"0.00","rpm":"1470","sfp":"0.000"},"op_is":{"airflowrate":40000,"externalpressure":400,"wsoll":19.505204158389144,"electricity":0,"elpower":0,"rpm":1470,"sfp":0}}'

                        /*
                        ????-parentsexists
                        ????-product_product_related_by_product_parent_ref_nos

                        op: Object { op_must: {…}, op_is: {…} }

                        electricity
                        elpower
                        rpm
                        sfp
                        volumeflow
                        wsoll
                        product_categories:
                         */

                        /*  Object.assign(query_params, {
                          airflowrate: row.op.op_must.airflowrate,
                          externalpressure: row.op.op_must.externalpressure,
                          airflow_unit: row.op.op_must.airflow_unit,
                          externalpressure_unit: row.op.op_must.externalpressure_unit,
                          externalpressuretyp: row.op.op_must.externalpressuretyp,
                          airflowrate_dev: row.op.op_must.airflowrate_dev, //&airflowrate_dev=-10&airflowrate_dev=10
                          externalpressure_dev: row.op.op_must.externalpressure_dev,
                          maxdba: row.op.op_must.maxdba,
                          airflowrate_is:row.op.op_is.airflowrate??'',
                          externalpressure_is:row.op.op_is.externalpressure??'',
                          wsoll_is:row.op.op_is.wsoll??''
                            https://select.local/de/get/product?ref_no=03265&version=030&execution=0&language_id=de&airflowrate=40000&externalpressure=400&airflow_unit=1&externalpressure_unit=5&externalpressuretyp=stat&airflowrate_dev=-10&airflowrate_dev=10&externalpressure_dev=-10&externalpressure_dev=10&maxdba=&airflowrate_is=40000&externalpressure_is=400&wsoll_is=19.505204158389144
                        });*/




                    })
                }
                else if(this.user.auth && parseInt(item.productSource) == 2 ){

                    /* this.user.articles = response.data*/
                    var found_article= articles.find(article => article.designation == item.productDescription)
                    if(found_article !== null && found_article !== undefined) {
                        materials[index].listprice = found_article.price>0 ? found_article.price.toFixed(2):0
                    }
                }
                materials[index].index = index
            }.bind(this))

            //--!!Object.assign(this.shoppingcartlist, materials);
            //--this.shoppingcartlist = materials  //.sort((a, b) => a.position - b.position)

            setTimeout(function() {
                this.$store.commit('shoppingcart/updateShoppingcartList', materials)
            }.bind(this), 2000);



            document.getElementsByTagName("body")[0].classList.remove("is-loading");
            this.listenerchild({nav:4,searchflag:''})
            /*this.validation(); */
        },
        async getUserProject() {


            var response = await projectApi.returnFullProjectData(this.session);
            if(response == 404 || !Array.isArray(response)){
                this.projectData = []
            } else if (response >= 400) {
                this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.load_project_data_faild')})
            } else{
                this.projectData = response
            }

        },
        async getUserArticles() {
            var response = await globalsApi.returnUserArticles(this.session); //this.user
            this.user.articles = response.data
        },
        async getUserSettings() {
            var response = await operatingpointApi.getUserSettings(this.session); //this.user
            this.$store.commit('operatingpoint/setSettings', response.data)
        },
        clearSession() {
            this.$store.dispatch('operatingpoint/resetState')
            this.configuration = null
            this.$store.dispatch('validation/resetState')
            this.$store.dispatch('projectData/resetState')
            this.$store.dispatch('shoppingcart/resetState')

            this.contentnav = 1
        },
        gotostartpage() {
            console.log('gotostartpage this.op')
            console.log(this.op)
            /*  this.selectedcategories = []
             this.op.airflow = ''
             this.op.pressure = ''
             this.op.pressuretype = 'stat'
             this.op.pressureunits = 5
             this.op.airflowunits = 1
             this.op.maxdba = ''
             this.airflow_deviation = this.makearray([-20, 20], [-20, 20])
             this.pressure_deviation = this.makearray([-20, 20], [-20, 20]) */



            this.contentnav = 1
        },

        getUserData() {
            console.log('Mainpage user.auth:')
            console.log(this.user.auth)
            if (this.user.auth) {
                axios.post('/user/basic/data').then(response => {
                    this.session = true;
                    console.log('Main this.user response data:')
                    console.log(response.data)

                    this.user = response.data;
                    this.getUserSettings()
                    /*own articles if api set articles we don't need this:*/
                    this.getUserArticles()
                    this.getUserProject()
                }).catch((error) => {
                    /*  console.log('error')
                        console.log(error)
                        this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.load_user_data_faild')}) */
                });
            }
        },
        //set selected category from homepage
        async setCategories(category) {
            var selected = []
            //ToDo first get categories   if (category is main cat => self, else childs)
            var categories
            var cd = {}
            var cats_desc = []


            var body = []
            body.push({
                language_id: this.$lang().locale, //navigator.language,
                category_id: category
            })
            var response = await operatingpointApi.getSelectedCategories(body);
            categories = response.categories;

            console.log('Categories response.categories');
            console.log(response.categories);


            var cats=categories.map(cat => {
                return ({ id: cat.id, description_short: cat.description_short})
            });


            cats.forEach((element, index, array) => {


                selected[element.id] = true
                Object.assign(cd, {
                    id: element.id,
                    desc: element.description_short
                })
                cats_desc.push(cd)

            });


            console.log('Categories permittedValues');
            console.log(cats);



            this.$store.commit('operatingpoint/setDescSelectedCategories', cats_desc)
            this.$store.commit('operatingpoint/updateSelectedCategories', selected);
        }
    },

    created(){

        console.log('MainPage created', window.session_has_user)
        console.log('session')
        console.log(this.session)
        console.log('status')
        console.log(this.status)
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 30000);
        console.log('MainPage this.configurationdata:')
        console.log(this.configurationdata)
        console.log('MainPage this.categorydata')
        console.log(this.categorydata)
        console.log('Mainpage user.auth:')
        console.log(this.user.auth)

        if (this.categorydata) {
            console.log('created categorydata')
            console.log(this.categorydata)

            this.setCategories(this.categorydata)
            window.history.replaceState(null, null, window.location.pathname);
        }


        if(this.configurationdata){
            // this.getUserData();
            this.getConfiguration({configuration_id: this.configurationdata})
            window.history.replaceState(null, null, window.location.pathname);
        }
        if(this.status == 1){  //ToDo:status request()->get('status') wird nicht in basic.blade gesetzt :(  in <sticky-header :status="{{request()->get('status') ? request()->get('status') : ''}}"></sticky-header>
            // this.getUserData();
            window.history.replaceState(null, null, window.location.pathname);
        }

        this.$root.$on("clearSession",({from})=>{
            //console.log("it's' called from",from)
            this.clearSession()
        })

        this.$root.$on("gotostartpage",({from})=>{
            //console.log("it's' called from",from)
            this.gotostartpage()
        })
        /*browser history:
        window.addEventListener('popstate', function (event) {
            // The popstate event is fired each time when the current history entry changes.

            var r = confirm("You pressed a Back button! Are you sure?!");

            if (r == true) {
                // Call Back button programmatically as per user confirmation.
                history.back();
                // Uncomment below line to redirect to the previous page instead.
                // window.location = document.referrer // Note: IE11 is not supporting this.
            } else {
                // Stay on the current page.
                history.pushState(null, null, window.location.pathname);
            }

            history.pushState(null, null, window.location.pathname);

        }, false);
        */
    },


    mounted () {
        $(this.$refs.iframemodal).on("hidden.bs.modal", this.resetIframe)
        console.log('this.feldererstate',this.feldererstate)
        if (this.feldererstate) {
            this.contentnav=1
            this.feldererstate=false
            //window.history.replaceState(null, null, window.location.pathname);
        }
    },
    destroyed () {
        this.cancelAutoUpdate();
    },

    watch: {
        navigation:{
            deep:true,
            handler (){
                console.log('watcher')
                if(this.navigation != '') this.setIframeUrl()
            },
        },
    }

}
</script>
<style>
.modal-dialog-scrollable .modal-content {
    overflow: visible;
    height: 100%;
    width: 100%;
    padding: 0.25rem;
}

#accountModal .modal-header .close {
    top: 0;
    right: 0;
}

#accountModal .modal-header .close:hover {
    opacity:1;
}

</style>
